var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools02-parameter-check"},[_c('el-row',[_c('el-col',[_c('h2',[_vm._v("パラメータチェック")])])],1),_c('el-row',[_c('el-col',[_c('Tools02ParameterCheckCheckingSystem',{attrs:{"toolId":_vm.toolId}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }